// src/ui/ActionSheet.tsx
import React from "react";
import { COLOR, FW, BORDER, RADIUS } from "@/ui/tokens";

export function ActionSheet({
                                open, onClose, actions, title
                            }: {
    open: boolean;
    onClose: () => void;
    actions: { label: string; onClick: () => void; danger?: boolean }[];
    title?: string;
}) {
    if (!open) return null;
    return (
        <div
            onClick={onClose}
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.4)",
                display: "grid",
                alignItems: "end",
                zIndex: 1000,              // 필요하면 1000으로 (다른 레이어 위에)
                userSelect: "none" as any,
                WebkitUserSelect: "none" as any,
                WebkitTouchCallout: "none" as any,
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    background: COLOR.white,
                    borderTopLeftRadius: RADIUS.lg,
                    borderTopRightRadius: RADIUS.lg,
                    padding: 12,
                    width: "min(680px, 92vw)",
                    margin: "0 auto",
                    boxShadow: "0 -10px 30px rgba(0,0,0,.15)",
                    // 이 WebView에서 vh는 시스템 UI를 포함해 어긋난다. main.tsx가 재서 세팅하는 --app-lvh를 쓴다.
                    maxHeight: "calc(var(--app-lvh, 100vh) * 0.8)",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {title && (
                    <div style={{ flex: "0 0 auto", padding: "10px 14px 12px", fontWeight: FW.extraBold, fontSize: 18, color: COLOR.text }}>
                        {title}
                    </div>
                )}
                {/* 항목이 많으면(구매처 목록 등) 시트 안에서 스크롤 — 닫기 버튼이 화면 밖으로 밀리지 않게.
                    minHeight:0 없으면 flex 아이템의 기본 min-height:auto 때문에 축소되지 않고
                    maxHeight를 뚫고 늘어나 목록이 화면 밖으로 잘려나간다. */}
                <div style={{ overflowY: "auto", flex: "1 1 auto", minHeight: 0, WebkitOverflowScrolling: "touch" as any }}>
                {actions.map((a, i) => (
                    <button
                        key={i}
                        onClick={() => { a.onClick(); onClose(); }}
                        onMouseDown={(e) => e.preventDefault()}
                        style={{
                            width: "100%",
                            padding: "18px 14px",
                            textAlign: "left",
                            fontWeight: FW.extraBold,
                            fontSize: 18,
                            border: "none",
                            background: "transparent",
                            color: a.danger ? "#dc2626" : COLOR.text,
                            borderBottom: i < actions.length - 1 ? BORDER.muted : "none",
                            cursor: "pointer",
                        }}
                    >
                        {a.label}
                    </button>
                ))}
                </div>
                <button
                    onClick={onClose}
                    onMouseDown={(e) => e.preventDefault()}
                    style={{
                        width: "100%",
                        padding: "16px 14px",
                        fontWeight: FW.bold,
                        border: "none",
                        background: "#f5f5f5",
                        borderRadius: RADIUS.md,
                        marginTop: 8,
                        flex: "0 0 auto",
                    }}
                >
                    닫기
                </button>
            </div>
        </div>
    );
}
